const state = {
  all: []
}

const mutations = {
  addNotification (state, notification) {
    if (notification.type === 'danger' && notification.message.body === '0 - undefined') {
      notification.message.body = 'Waiting For Database Connection'
    }
    state.all.push(notification)
  },
  resetNotifications (state) {
    state.all = []
  }
}
const actions = {
  resetNotificationsAction () {
    state.all = []
  }
}
const getters = {
  all: state => {
    return state.all
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/notifications.js